(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["related-products"]) return;
  try {
    

let maintProductContainer = document.querySelector(".main-product-container")
let productId = maintProductContainer ? parseFloat(maintProductContainer.getAttribute("id")) : null
const store_url = `https://quintalatelier.com${window.Shopify.routes.root}`

let allProducts = [];

function fetchProducts(page){
    return new Promise((resolve, reject) => {
        fetch(`${store_url}/products.json?limit=250&page=${page}`)
            .then(response => response.json())
            .then(({ products }) => {
                if (products.length > 0 ){
                    const nextPage = page + 1
                    fetchProducts(nextPage)
                    allProducts.push(...products)
                } else {
                    makeRecommendation()
                    resolve()
                }
            }
        )
    })
}

function normalizeString(string){
    let outpoutString = string.toLowerCase()
    outpoutString = outpoutString.normalize("NFD")
    outpoutString = outpoutString.replace(/[\u0300-\u036f]/g, "")
    outpoutString = outpoutString.replace(/œ/g, "oe")
    return outpoutString
}

function getMainProductAuthors(){
    let authors = document.querySelector("#main-product-author").innerHTML
    authors = authors.replace(" et ", ", ")
    authors = authors.replace(" and ", ", ")
    authors = normalizeString(authors)
    return authors.split(", ")
}

function findMatchingAuthors(){
    const authors = getMainProductAuthors()
    return allProducts.filter((product) => {
       let found = false
       authors.forEach((author) => {
            if (normalizeString(product.body_html).includes(author)) {
                found = true
            }
       })
       if (product.id === productId ){
        return false
       } else {
        return found
       }
    })
}

function findMatchingVendors(){
    const vendor = document.querySelector(".main-product-container").getAttribute("vendor")
    return allProducts.filter((product) => {
        if (product.id === productId ){
            return false 
        } else {
            return product.vendor === vendor
        }
    })
}

function shuffleArray(array){ 
    return array.map((a) => ({ sort: Math.random(), value: a }))
        .sort((a, b) => a.sort - b.sort)
        .map((a) => a.value); 
}

function getRandomProduct(array, n) {
    var result = new Array(n),
        len = array.length,
        taken = new Array(len);
    while (n--) {
        var x = Math.floor(Math.random() * len);
        result[n] = array[x in taken ? taken[x] : x];
        taken[x] = --len in taken ? taken[len] : len;
    }
    return result;
}

function makeRecommendation(){
    const recommendedProducts = []

    if (productId){

        let matchingAuthors = findMatchingAuthors()
        matchingAuthors = shuffleArray(matchingAuthors)
        recommendedProducts.push(...matchingAuthors)
        
        if (recommendedProducts.length < 4) {
            let matchingVendors = findMatchingVendors()
            matchingVendors = shuffleArray(matchingVendors)
            recommendedProducts.push(...matchingVendors)
        }
    }

    if (recommendedProducts.length < 4) {
        const randomProduct = getRandomProduct(allProducts, 5)
        randomProduct.filter((product) => product.id !== productId);
        recommendedProducts.push(...randomProduct)
    }

    displayRecommendedProducts(recommendedProducts.slice(0,4))

}

function displayRecommendedProducts(recommendedProducts){
    const gridContainer = document.querySelector(".product-grid-container")

    recommendedProducts.forEach((product) => {

        const url = `${store_url}products/${product.handle}`

        fetch(url)
        .then((response) => response.text())
        .then((data) => new DOMParser().parseFromString(data, "text/html"))
        .then((parsed_data) => {

            let gridItem = document.createElement("a")
            gridItem.setAttribute("class", "product-grid-item")
            gridItem.setAttribute("href", url)
            gridItem.setAttribute("title", product.title)

            let img = document.createElement("img")
            img.setAttribute("src", product.images[0].src)
            gridItem.append(img)

            let gridItemTitle = document.createElement("div")
            gridItemTitle.setAttribute("class", "product-grid-item-title")
            gridItemTitle.innerHTML = product.title
            gridItem.append(gridItemTitle)

            let gridItemAuthor = document.createElement("div")
            gridItemAuthor.setAttribute("class", "product-grid-item-author")
            gridItemAuthor.innerHTML = parsed_data.querySelector("#main-product-author").innerHTML
            gridItem.append(gridItemAuthor)
        
            let gridItemPrice = document.createElement("div")
            gridItemPrice.setAttribute("class", "product-grid-item-price")
            let mainProductPrice = document.createElement("div")
            mainProductPrice.setAttribute("class", "main-product-price")
            mainProductPrice.innerHTML = parsed_data.querySelector(".main-product-price").innerHTML
            gridItemPrice.append(mainProductPrice)
            gridItem.append(gridItemPrice)

            gridContainer.append(gridItem);

        })
        
    })
}

fetchProducts(1)


  } catch(e) { console.error(e); }
})();
})();
